import { createSelector } from '@reduxjs/toolkit';

export const getCmsPage = state => state.cmsPage;

export const getComponents = state => state.cmsPage?.locations?.root;

export const getLoading = state => state.cmsPage?.loading;

export const getMetaData = createSelector([state => state.cmsPage?.metaData], metaData => {
  return {
    ...metaData,
    keywords: metaData?.keywords?.length ? metaData.keywords.join(',') : null,
  };
});

export const getPageTitle = state => state.cmsPage?.pageTitle || {};

export const getLocationHash = state => state.router?.location?.hash || null;

export const getPageNotFound = state => state.cmsPage?.pageNotFound || false;
